import { BridgeComponent } from '@hotwired/hotwire-native-bridge'

export default class extends BridgeComponent<HTMLButtonElement> {
  static component = 'bridge--switch-tenant'

  onSwitchTenant() {
    this.send('switch_tenant_requested')
  }
}
